import { useAuth } from '../context/AuthContext';
import { Clock, AlertTriangle, LogOut } from 'lucide-react';

const SessionTimeoutModal = () => {
  const { showTimeoutWarning, timeoutCountdown, extendSession, logout } = useAuth();

  if (!showTimeoutWarning) return null;

  return (
    <div className="fixed inset-0 z-[100] flex items-center justify-center">
      {/* Backdrop */}
      <div className="absolute inset-0 bg-slate-900/80 backdrop-blur-sm" />
      
      {/* Modal */}
      <div className="relative bg-white rounded-2xl shadow-2xl max-w-md w-full mx-4 overflow-hidden">
        {/* Header */}
        <div className="bg-gradient-to-r from-amber-500 to-amber-600 px-6 py-4">
          <div className="flex items-center gap-3">
            <div className="w-10 h-10 bg-white/20 rounded-full flex items-center justify-center">
              <AlertTriangle className="w-5 h-5 text-white" />
            </div>
            <div>
              <h2 className="text-lg font-semibold text-white">Session Timeout Warning</h2>
              <p className="text-amber-100 text-sm">Your session is about to expire</p>
            </div>
          </div>
        </div>
        
        {/* Body */}
        <div className="p-6">
          <div className="flex flex-col items-center text-center mb-6">
            <div className="w-20 h-20 bg-amber-100 rounded-full flex items-center justify-center mb-4">
              <Clock className="w-10 h-10 text-amber-600" />
            </div>
            <p className="text-slate-600 mb-2">
              Due to inactivity, your session will expire in:
            </p>
            <div className="text-5xl font-bold text-slate-800 font-mono">
              {timeoutCountdown}
            </div>
            <p className="text-slate-500 text-sm mt-1">seconds</p>
          </div>
          
          <p className="text-sm text-slate-500 text-center mb-6">
            For your security, we automatically log you out after 45 minutes of inactivity. 
            Click "Continue Session" to remain logged in.
          </p>
          
          {/* Actions */}
          <div className="flex gap-3">
            <button
              onClick={logout}
              className="flex-1 px-4 py-3 border border-slate-300 text-slate-700 rounded-lg font-medium hover:bg-slate-50 transition-colors flex items-center justify-center gap-2"
              data-testid="logout-now-btn"
            >
              <LogOut className="w-4 h-4" />
              Log Out Now
            </button>
            <button
              onClick={extendSession}
              className="flex-1 px-4 py-3 bg-gradient-to-r from-emerald-500 to-emerald-600 text-white rounded-lg font-medium hover:from-emerald-600 hover:to-emerald-700 transition-colors shadow-lg shadow-emerald-500/25"
              data-testid="continue-session-btn"
            >
              Continue Session
            </button>
          </div>
        </div>
        
        {/* Progress bar */}
        <div className="h-1 bg-slate-200">
          <div 
            className="h-full bg-amber-500 transition-all duration-1000 ease-linear"
            style={{ width: `${(timeoutCountdown / 60) * 100}%` }}
          />
        </div>
      </div>
    </div>
  );
};

export default SessionTimeoutModal;
